export default __webpack_public_path__ + "static/media/41.24d87db2.gif";